import { render } from "./Question.vue?vue&type=template&id=5b623736&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=5b623736&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b623736"],['__file',"src/apps/quiz/routes/Question.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b623736"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b623736', __exports__)) {
    api.reload('5b623736', __exports__)
  }
  
  module.hot.accept("./Question.vue?vue&type=template&id=5b623736&scoped=true", () => {
    api.rerender('5b623736', render)
  })

}


export default __exports__